export const getters = {
  attributs(state) {
    return state.attributs;
  },
  attribut(state) {
    return state.attribut;
  },
  pagination(state) {
    return state.pagination;
  },
};
